var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.show_general_registration_of_changes,"persistent":"","max-width":"600"}},[_c('RegistrationOfChangeLocal',{attrs:{"item":_vm.item,"dialog":_vm.show_general_registration_of_changes,"title":"Реєстрація зміни для перерахунку"},on:{"closeModal":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }